import React, { useState } from 'react';
import { ArrowRight, Check, Minus, ChevronDown } from 'lucide-react';
import { PLANS, COMPARE, applyNow } from './homeData';

const ScopeList = ({ id, items, open }) => (
  <ul className="yv-pkg-list" data-testid={`plan-${id}-features`}>
    {items.map(([t, d]) => (
      <li key={t} className={t.startsWith('Everything') ? 'is-prev' : ''}>
        <Check className="w-4 h-4" aria-hidden="true" />
        <span><b className="yv-pkg-item">{t}</b>{d && open && <span className="yv-pkg-desc">{d}</span>}</span>
      </li>
    ))}
  </ul>
);

const PlanCard = ({ plan }) => {
  const [open, setOpen] = useState(false);
  return (
    <article id={`plan-${plan.id}`} className={`yv-pkg ${plan.featured ? 'is-featured' : ''}`} data-testid={`plan-${plan.id}`}>
      {plan.featured && <span className="yv-pkg-flag" data-testid="plan-featured-flag">Featured Solution</span>}
      <span className="yv-mono yv-pkg-n">System {plan.n}</span>
      <h3 className="yv-pkg-name">{plan.name}</h3>
      <p className="yv-pkg-pos">{plan.positioning}</p>
      <div className="yv-pkg-label">What YOVAI Implements</div>
      <ScopeList id={plan.id} items={plan.implement} open={open} />
      <div className="yv-pkg-label">What YOVAI Manages After Launch</div>
      <ScopeList id={`${plan.id}-manage`} items={plan.manage} open={open} />
      <button className="yv-pkg-toggle" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`plan-${plan.id}-details-toggle`}>
        {open ? 'Hide Scope Details' : 'Show Scope Details'} <ChevronDown className={`w-4 h-4 ${open ? 'rotate-180' : ''}`} aria-hidden="true" />
      </button>
      <div className="yv-pkg-best"><span className="yv-pkg-label">Best For</span><p>{plan.bestFor}</p></div>
      <button onClick={() => applyNow(plan.id)} className={`yv-btn ${plan.featured ? 'yv-btn-primary' : 'yv-btn-ghost'} yv-btn-block`} data-testid={`plan-${plan.id}-cta`}>
        Apply For A Consultation <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </button>
    </article>
  );
};

const Cell = ({ v }) => {
  if (v === 'scope') return <span className="yv-cmp-scope">Available By Scope</span>;
  return v ? <Check className="w-4 h-4 yv-cmp-yes" aria-label="Included" /> : <Minus className="w-4 h-4 yv-cmp-no" aria-label="Not included" />;
};

const Comparison = () => (
  <div className="yv-cmp-wrap" data-testid="package-comparison">
    <table className="yv-cmp">
      <caption className="yv-mono">Package Comparison</caption>
      <thead>
        <tr><th scope="col">Capability</th>{PLANS.map((p) => <th key={p.id} scope="col" className={p.featured ? 'is-featured' : ''}>{p.name.replace(' System', '').replace(' Operations', '')}</th>)}</tr>
      </thead>
      <tbody>
        {COMPARE.map(([label, ...vals]) => (
          <tr key={label} data-testid={`compare-row-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
            <th scope="row">{label}</th>
            {vals.map((v, i) => <td key={PLANS[i].id} className={PLANS[i].featured ? 'is-featured' : ''}><Cell v={v} /></td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const SystemsPricing = () => (
  <section id="systems" className="yv-section yv-bg-white" data-testid="systems-section">
    <div className="yv-container">
      <div className="yv-section-head yv-split-head">
        <div>
          <p className="yv-eyebrow">Service Packages</p>
          <h2 className="yv-h2">Three Service Levels. <span className="yv-blue-ink yv-block">One Connected Standard.</span></h2>
        </div>
        <p className="yv-lede">Each Package Is Scoped Around Your Operations. Your Consultation Determines The Right Level, Deliverables, And Implementation Plan.</p>
      </div>
      <div className="yv-pkgs" data-testid="plans-grid">
        {PLANS.map((p) => <PlanCard key={p.id} plan={p} />)}
      </div>
      <Comparison />
      <p className="yv-fine" data-testid="plans-pricing-note">Service Fees, Implementation Costs, Billing Schedules, And Ongoing Support Arrangements Are Defined In Each Client’s Approved Proposal And Service Agreement.</p>
    </div>
  </section>
);
